export default "__VITE_ASSET__CU1nhTJx__"